import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    description:
      'Once the request is validated by an account admin, you will find the transfer in the “Transactions” tab.',
    loadMore: 'Load more',
    noRequestsDescription:
      'Here you will find your current transfer requests, to be validated by the account holder.',
    noRequestsTitle: 'No transfer initiated',
    requestBankTransfer: 'Request a bank transfer',
    title: 'Bank transfers',
  },
  fr: {
    description:
      'Une fois la demande validée par un·e admin du compte, retrouvez le virement dans l’onglet “Transactions”.',
    loadMore: 'Charger plus',
    noRequestsDescription:
      'Retrouvez ici vos demandes de virements en cours, à valider par le ou la titulaire du compte.',
    noRequestsTitle: 'Aucun virement initié',
    requestBankTransfer: 'Initier un virement',
    title: 'Virements',
  },
} as const);

export default locales;
